// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// export const environment = {
//   production: false,
//   clientUrl: 'http://localhost:4200/funCog',
//   reportUrl: 'http://localhost:4200/report',
//   therapistUrl: 'http://localhost:4200/therapist',
//   apiUrl: 'http://localhost/drivingAssessment/',
//   passwordResetUrl: 'http://localhost:4200/reset-password'
// };

export const environment = {
  production: true,
  clientUrl: 'https://demo.going-places.co.za/funCog',
  reportUrl: 'https://demo.going-places.co.za/report',
  therapistUrl: 'https://demo.going-places.co.za/therapist',
  apiUrl: 'https://demo.going-places.co.za/',
  passwordResetUrl: 'https://demo.going-places.co.za/reset-password'
};


// export const environment = {
//   production: true,
//   clientUrl: 'https://complete.going-places.co.za/funCog',
//   reportUrl: 'https://complete.going-places.co.za/report',
//   therapistUrl: 'https://complete.going-places.co.za/therapist',
//   apiUrl: 'https://complete.going-places.co.za/',
//   passwordResetUrl: 'https://complete.going-places.co.za/reset-password'
// };


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
